import React from "react";
import { useNavigate } from "react-router-dom";
import { Users } from "lucide-react";
import { useAuth } from "../hooks/useAuth";
import "../styles/auth.css";

export default function DashboardPage() {
    const { user } = useAuth();
    const navigate = useNavigate();

    return (
        <div className="dashboard-card">
            <h1>Welcome, {user?.fullname}</h1>
            <p>You are logged in to RMT-AI.</p>
            <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
                <button
                    className="dashboard-logout"
                    style={{ borderColor: "#fe611b", color: "#fe611b" }}
                    onClick={() => navigate("/clients")}
                >
                    <Users size={16} />
                    My Clients
                </button>
            </div>
        </div>
    );
}
